import { UPDATE_SHOPPING_LIST_DETAILS } from './types';

export const updateShoppingListDetailsAction = (updateShoppingListDetails) => dispatch => {
    dispatch({
        type: UPDATE_SHOPPING_LIST_DETAILS,
        updateShoppingListDetails: updateShoppingListDetails,
    })
}